import AuthUtil from '../redux/AuthUtil';
import { SPACE } from '../components/global/Server/endpoints';

// Thin wrapper over the /space endpoints.
// Session cache for the space list (used by the always-visible workspace
// indicator so it doesn't refetch on every screen). Switching spaces reloads
// the page, which clears this.
let _listCache = null;

// Fired when the space list changes (rename / create / delete). The always-
// visible WorkspaceIndicator listens for this and refetches, so a rename shows
// in the top-left pill without a page reload. Also clears the session cache so
// the next listCached() is fresh.
export const SPACES_CHANGED_EVENT = 'beenexa:spaces-changed';
export function notifySpacesChanged() {
  _listCache = null;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SPACES_CHANGED_EVENT));
  }
}

const spaceApi = {
  list: () => AuthUtil.getRequest(SPACE.LIST),
  listCached: () => {
    if (!_listCache) {
      _listCache = AuthUtil.getRequest(SPACE.LIST)
        .then((r) => (Array.isArray(r?.data) ? r.data : []))
        .catch(() => []);
    }
    return _listCache;
  },
  create: (name) => AuthUtil.postRequest(SPACE.CREATE, { name }),
  invite: (spaceId, email, role) => AuthUtil.postRequest(SPACE.INVITE, { spaceId, email, role }),
  members: (spaceId) => AuthUtil.postRequest(SPACE.MEMBERS, { spaceId }),
  rename: (spaceId, name) => AuthUtil.postRequest(SPACE.RENAME, { spaceId, name }),
  removeMember: (spaceId, member) =>
    AuthUtil.postRequest(SPACE.REMOVE_MEMBER, { spaceId, userId: member.userId, email: member.email }),
  updateRole: (spaceId, member, role) =>
    AuthUtil.postRequest(SPACE.UPDATE_ROLE, { spaceId, userId: member.userId, email: member.email, role }),
  deleteSpace: (spaceId) => AuthUtil.postRequest(SPACE.DELETE, { spaceId }),
  pendingInvites: () => AuthUtil.getRequest(SPACE.PENDING_INVITES),
  acceptInvite: (spaceId) => AuthUtil.postRequest(SPACE.ACCEPT_INVITE, { spaceId }),
  declineInvite: (spaceId) => AuthUtil.postRequest(SPACE.DECLINE_INVITE, { spaceId }),
};

export default spaceApi;
